import { render, staticRenderFns } from "./SalerListCell.vue?vue&type=template&id=2c34a4ca&scoped=true"
import script from "./SalerListCell.vue?vue&type=script&lang=js"
export * from "./SalerListCell.vue?vue&type=script&lang=js"
import style0 from "./SalerListCell.vue?vue&type=style&index=0&id=2c34a4ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@2.0.1_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c34a4ca",
  null
  
)

export default component.exports